import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  REDO_REASON_OPTIONS,
  RedoReason,
} from '../../../../constants/redo-reasons';

export interface RedoOrderDialogData {
  invoiceNumber?: string;
}

@Component({
  selector: 'app-redo-order-dialog',
  template: `
    <h2 mat-dialog-title>REASON FOR RE-DO</h2>
    <mat-dialog-content>
      <p class="redo-dialog-message">
        Select one primary reason before the Re-do job is created.
      </p>
      <p *ngIf="data?.invoiceNumber" class="redo-dialog-invoice">
        Original invoice: {{ data.invoiceNumber }}
      </p>
      <mat-radio-group [(ngModel)]="reason" class="redo-dialog-reasons">
        <mat-radio-button
          *ngFor="let option of options"
          class="redo-dialog-reason"
          [value]="option"
        >
          {{ option }}
        </mat-radio-button>
      </mat-radio-group>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="cancel()">CANCEL</button>
      <button
        mat-raised-button
        color="primary"
        type="button"
        [disabled]="!canConfirm"
        (click)="confirm()"
      >
        RE-DO
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .redo-dialog-message {
        margin: 0 0 12px;
        font-size: 13px;
        line-height: 1.4;
      }
      .redo-dialog-invoice {
        margin: 0 0 12px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
      }
      .redo-dialog-reasons {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
      .redo-dialog-reason {
        display: block;
        white-space: normal;
      }
    `,
  ],
})
export class RedoOrderDialogComponent {
  options = REDO_REASON_OPTIONS;
  reason: RedoReason | '' = '';

  constructor(
    public dialogRef: MatDialogRef<RedoOrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RedoOrderDialogData
  ) {}

  get canConfirm(): boolean {
    return !!this.reason;
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  confirm(): void {
    if (!this.canConfirm) {
      return;
    }
    this.dialogRef.close(this.reason);
  }
}
